export const ContactUsInquiryTypes = {
  General: 'general',
  Technical: 'technical',
};

export const ContactUsInquiryTypeTitles = {
  [ContactUsInquiryTypes.General]: 'General',
  [ContactUsInquiryTypes.Technical]: 'Technical',
};
